import {Introduction} from './components'
import ThirdPartyIntegration from './components/ThirdPartyIntegration'
import requireAuth from '../../utils/requireAuth'
import RoleBasedAccess from '../../utils/RoleBasedAccess'
import CurrenciesIndex from './components/CurrenciesIndex'

export const configRoutes = [
    {
        path:'configure/introduction',
        component:requireAuth(RoleBasedAccess(Introduction,['console','introduction','R'])),
        key:'Introduction'
    },
    {
        path:'configure/third-party-integration',
        component:requireAuth(RoleBasedAccess(ThirdPartyIntegration,['console','3rd_party_integration','R'])),
        key:'ThirdPartyIntegration'
    },
    {
        path:'configure/currencies',
        component:requireAuth(CurrenciesIndex),
        key:'currencies'
    },
]